<template>
  <component :is="stepComponent" v-if="stepComponent && isStepVisible" :step="currentStep" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'

import WelcomeStep from './WelcomeStep.vue'
import GenderStep from './GenderStep.vue'
import BrandSelectionStep from './BrandSelectionStep.vue'
import StyleSelectionStep from './StyleSelectionStep.vue'
import ColorSelectionStep from './ColorSelectionStep.vue'
import HeelFrequencyStep from './HeelFrequencyStep.vue'
import TinderLikeStep from './TinderLikeStep.vue'
import ChoiceStep from './ChoiceStep.vue'
import ThankYouStep from './ThankYouStep.vue'
import LaterStep from './LaterStep.vue'
import ResultsChoiceStep from './ResultsChoiceStep.vue'
import StyleEvaluationStep from './StyleEvaluationStep.vue'

const tasteStore = useTasteClarificationModal()
const currentStep = computed(() => tasteStore.currentStep)

const isStepVisible = computed(() => {
  const step = currentStep.value
  if (!step) return false
  
  // Статический шаг "later" всегда видим, если он активен
  if (step.type === 'later') {
    return true
  }
  
  return tasteStore.shouldStepBeVisible(step)
})

const stepComponent = computed(() => {
  const step = currentStep.value
  if (!step) return null

  // Special case: results-choice step uses different component
  if (step.type === 'choice' && step.id === 'results-choice') {
    return ResultsChoiceStep
  }

  // Special case: style-evaluation-choice step uses ChoiceStep component
  if (step.id === 'style-evaluation-choice') {
    return ChoiceStep
  }

  switch (step.type) {
    case 'welcome':
      return WelcomeStep
    case 'gender':
      return GenderStep
    case 'brand_selection':
      return BrandSelectionStep
    case 'style_selection':
      return StyleSelectionStep
    case 'color_selection':
      return ColorSelectionStep
    case 'heel_frequency':
      return HeelFrequencyStep
    case 'tinder_like':
      return TinderLikeStep
    case 'choice':
      return ChoiceStep
    case 'thank_you':
      return ThankYouStep
    case 'later':
      return LaterStep
    case 'style_evaluation':
      return StyleEvaluationStep
    default:
      console.warn(`Unknown step type: ${(step as any).type}`)
      return null
  }
})
</script>

